/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Actions_TitleInputs */

const en_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Actions`)
};

const de_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Aktionen`)
};

const fr_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions IA`)
};

const es_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones IA`)
};

const it_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni AI`)
};

const nl_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-acties`)
};

const pl_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akty AI`)
};

const fi_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-toimet`)
};

const da_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-handlinger`)
};

const sv_settings_ai_actions_title = /** @type {(inputs: Settings_Ai_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-aktioner`)
};

/**
* | output |
* | --- |
* | "AI Actions" |
*
* @param {Settings_Ai_Actions_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_title = /** @type {((inputs?: Settings_Ai_Actions_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_title(inputs)
	if (locale === "fr") return fr_settings_ai_actions_title(inputs)
	if (locale === "es") return es_settings_ai_actions_title(inputs)
	if (locale === "it") return it_settings_ai_actions_title(inputs)
	if (locale === "nl") return nl_settings_ai_actions_title(inputs)
	if (locale === "pl") return pl_settings_ai_actions_title(inputs)
	if (locale === "fi") return fi_settings_ai_actions_title(inputs)
	if (locale === "da") return da_settings_ai_actions_title(inputs)
	if (locale === "sv") return sv_settings_ai_actions_title(inputs)
	return en_settings_ai_actions_title(inputs)
});